import Vue from 'vue';
import VueI18n from 'vue-i18n';

import elementEnLocale from 'element-ui/lib/locale/lang/en';
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN';

import enLocale from './en/index';
import zhLocale from './zh/index';

Vue.use(VueI18n);

const messages = {
  'en': {
    ...enLocale,
    ...elementEnLocale,
  },
  'zh-cn': {
    ...zhLocale,
    ...elementZhLocale,
  },
};

export const getLocale = () => {
  return 'zh-cn';
};

const i18n = new VueI18n({
  locale: getLocale(),
  messages,
});

export default i18n;
